module.exports = require("lodash/invoke");